var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.showPhone}},[_c('div',{staticClass:"box"},[_c('p',{staticClass:"num"},[_vm._v(_vm._s(_vm.combinPhone))]),_c('div',{staticClass:"bth"},[_c('span',{on:{"click":_vm.cancal}},[_vm._v("取消")]),_c('span',{on:{"click":_vm.confirm}},[_vm._v("呼叫")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }